<template>
  <div>
    <nav-bar/>
    <buy-art/>
    <div class="padded on-the-left">
      <p>If you have bought Art 3.0 and are not the most recent owner then your original investment plus your 40% profit will be available to withdraw here.</p>
      <p>To have the piece shipped to you, you must be the most recent buyer and the previous person that received it must have had it in their possesion for a minimum of four weeks.
        Once you request shipping your future funds will be locked, they will be unlocked once you send it on to the next requestor or back to the artist.</p>
      <p>Available to withdraw: {{ balanceEth }} ETH</p>
      <b-button @click="withdraw">Withdraw now</b-button>
      <b-button @click="requestShipment">Request shipment</b-button>
    </div>
    
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import BuyArt from '@/components/BuyArt'
import Web3 from 'web3'
export default {
  name: 'collector-admin',
  components: {
    'nav-bar': NavBar,
    'buy-art': BuyArt
  },
  data () {
    return {
      toAddress: null,
      toAmount: 0,
      web3: null,
      web3Provider: null,
      balance: 0,
      balanceEth: 0,
      contracts: {},
      account: null,
      displayName: null,
      contactData: null
    }
  },
  mounted () {
    this.getProvider()
  },
  methods: {
    withdraw() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance;
          this.account = accounts[0];
          console.log(this.account);
          return art30Instance.withdrawCollectorFunds({from: this.account})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    requestShipment() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.account = accounts[0];
        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance;
          console.log(this.account);
          return art30Instance.requestShipment({from: this.account})
        }).then((result) => {
          console.log(result)
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    onSubmit (evt) {
      evt.preventDefault();
    },
    getProvider () {
      // Checking if Web3 has been injected by the browser (Mist/MetaMask)
      if (typeof web3 !== 'undefined') {
        // Use Mist/MetaMask's provider
        this.web3Provider = web3.currentProvider
        web3 = new Web3(this.web3Provider)
      } else {
        // fallback - use your fallback strategy (local node / hosted node + in-dapp id mgmt / fail)
        this.web3Provider = new Web3.providers.HttpProvider('http://localhost:8545')
        web3 = new Web3(this.web3Provider)
      }
      this.getContract()
    },
    getContract () {
      var Art30Artifact = require('../../build/contracts/Art30.json')
      this.contracts.Art30 = this.$TruffleContract(Art30Artifact)
      this.contracts.Art30.setProvider(this.web3Provider)
      this.networkCheck()
      //this.getAccount()
      this.getBalances()
    },
    networkCheck () {
      web3.version.getNetwork((err, netId) => {
        if (err) {
          console.log(err)
          return
        }
        switch (netId) {
          case '1':
            console.log('This is mainnet')
            break
          case '2':
            console.log('This is the deprecated Morden test network.')
            break
          case '3':
            console.log('This is the ropsten test network.')
            break
          default:
            console.log('This is an unknown network.')
        }
      })
    },
    getBalances () {
      var account
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.account = accounts[0]
        //console.log(accounts[0])

        this.contracts.Art30.deployed().then((instance) => {
          var art30Instance = instance
          return art30Instance.getCollectorBalance(this.account)
        }).then((result) => {
          console.log(result)
          this.balance = result.valueOf()
          this.balanceEth = web3.fromWei(result, 'ether').valueOf()
        }).catch((err) => {
          console.log(err.message)
        })
      })
    },
    getAccount() {
      web3.eth.getAccounts((error, accounts) => {
        if (error) {
          console.log(error)
          return
        }
        this.account = accounts[0]
        console.log(this.account)
      })
    }
  }
}
</script>

<style scoped>
.on-the-left {
    text-align: left;
}

.padded {
    padding: 0 10pc;
}
</style>


// WEBPACK FOOTER //
// src/components/CollectorAdmin.vue